import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../constants.jsx";
import bcrypt from 'bcryptjs';
import {paramarshMenu,paramarshExpertMenu,paramarshUserMenu} from "../constants.jsx"

const salt = bcrypt.genSaltSync(10);


const getRoute = (prefix, menu) => {
  let routes = [];

  if (Array.isArray(menu)) {
    menu.forEach((item) => {
      routes = routes.concat(getRoute(prefix, item));
    });
  } else {
    const tempPrefix =
      prefix === "/"
        ? prefix + "" + menu.moduleName
        : prefix + "/" + menu.moduleName;

    let subMenus;
    if (menu?.firstData) {
      subMenus = menu.firstData;
    } else if (menu?.secondData) {
      subMenus = menu?.secondData;
    } else if (menu?.thirdData) {
      subMenus = menu.thirdData;
    }

    if (subMenus !== undefined && subMenus.length > 0) {
      routes = routes.concat(getRoute(tempPrefix, subMenus));
    } else {
      routes.push({
        menu: menu.moduleDisplayName,
        path: tempPrefix,
      });
      
     

      // TODO: Remove second condition in production mode (it is only for testing purposes).

      if ((menu.addData && menu.addData === "Y") || !menu.addData) {
        routes.push(
          {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/add"),
        },
          {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/add/:id"),
        },
          {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/:id"),
        },
          {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/:id/:id2"),
        },
          
          {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/userbookslot/add"),
        },
          {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/userbookslot/add/:id"),
        },
          {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/userbookslot/bookslotmain/add/:id/:id2"),
        },
          {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/userbookslot/bookslotmain/add/:id/:id2/:id3"),
        },
        {
          menu: menu.moduleDisplayName.concat(" AddData"),
          path: tempPrefix.concat("/userbookslot/:id"),
        },
       
         
         
        );
      }
      if ((menu.editData && menu.editData === "Y") || !menu.editData) {
        routes.push({
          menu: menu.moduleDisplayName.concat(" EditData"),
          path: tempPrefix.concat("/edit/:id"),
        },
        {
          menu: menu.moduleDisplayName.concat(" EditData"),
          path: tempPrefix.concat("/userbookslot/:id"),
        },
        {
          menu: menu.moduleDisplayName.concat(" EditData"),
          path: tempPrefix.concat("/manageexpertAvailability/:id"),
        },
        {
          menu: menu.moduleDisplayName.concat(" EditData"),
          path: tempPrefix.concat("/manageexpertslotbooking/:id"),
        },
        
       
      
        );
      }
      if ((menu.deleteData && menu.deleteData === "Y") || !menu.deleteData) {
        routes.push({
          menu: menu.moduleDisplayName.concat(" DeleteData"),
          path: tempPrefix.concat("/delete/:id"),
        });
      }
      if (
        (menu.downloadData && menu.downloadData === "Y") ||
        !menu.downloadData
      ) {
        routes.push({
          menu: menu.moduleDisplayName.concat(" DownloadData"),
          path: tempPrefix.concat("/downloadData"),
        });
      }
    }
  }
  return routes;
};

export const loginUser = createAsyncThunk(
  "user/loginUser",
 
  async (userCredentials, { rejectWithValue }) => {

    try {

      
      const request = await axios.post(
        `${BASE_URL}/users/login`,
        userCredentials
      );
     
    
      const response = await request.data;

      let errorMessage = "Something went Wrong!!";


        if (response.userData.status && response.userData.status === "A") {
          console.log('response test',response.userData.status);

          let user = null;
          let menu = null;
          let Authorization = null;
          let authorizedRoutes = {};
          let SESSION_DATA = [];

          const userPassword = bcrypt.hashSync(`${userCredentials.password}`, salt);
          if (response !== undefined) {
            user = response.userData;
           console.log('user test result',user)

            // menu = result.menuData;
            // menu = paramarshMenu;
            menu = user.usertype == "user"?paramarshUserMenu:user?.usertype === "expert"?paramarshExpertMenu:paramarshMenu;
console.log("test menu data",menu);
            // Authorization = request.headers.get('Authorization');
            Authorization = response.accessToken;
            authorizedRoutes = getRoute("/", menu);
            let USER_ID=null,USER_EMAIL = null,USER_TYPE=null,USER_NAME=null,USER_STATUS = null
            
        

           
              USER_ID = user?.id;
              USER_EMAIL = user?.email;
              USER_NAME = user?.username;
              USER_TYPE = user?.userType;
              USER_STATUS = user?.status;
            
            SESSION_DATA.push({
            

              PARAMARSH_USER_LOGGED_IN :  true,
              PARAMARSH_USER_ID :  USER_ID,
              PARAMARSH_USER_EMAIL :  USER_EMAIL,
              PARAMARSH_USER_NAME :  USER_NAME,
              PARAMARSH_USER_TYPE :  USER_TYPE,
              PARAMARSH_USER_STATUS :  USER_STATUS,
             
             

            });
          }
          return { user, menu, authorizedRoutes, Authorization, SESSION_DATA };
        } else {
          errorMessage = response.response?.statusMessage;
          console.log("errorMessage",errorMessage)
        }
      

      return rejectWithValue(errorMessage);
    } catch (error) {
      console.log("error=",error.response.data.message);
      return rejectWithValue(error.response.data.message);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    loading: false,
    user: null,
    menu: null,
    // userGroupPosition: null,
    Authorization: null,
    authorizedRoutes: null,
    SESSION_DATA: null,
    error: null,
  },
  reducers: {
    logoutUser: (state) => {
      state.loading = false;
      state.user = null;
      state.menu = null;
      // state.userGroupPosition = null;
      state.Authorization= null;
      state.authorizedRoutes = null;
      state.SESSION_DATA = null;
      state.error = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.user = null;
        state.Authorization= null;
        state.SESSION_DATA= null;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.menu = action.payload.menu;
        // state.menu = paramarshUserMenu;
        // state.userGroupPosition = action.payload.userGroupPosition;
        state.Authorization= action.payload.Authorization;
        state.authorizedRoutes = action.payload.authorizedRoutes;
        state.SESSION_DATA = action.payload.SESSION_DATA;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        if (action.error.message === "Request failed with status code 400") {
          state.error = "Access denied!! Invalid Credentials";
        } else {
          console.log("action.error.message",action.error.message)
          state.error = action.error.message;
        }
      });
  },
});

export const { logoutUser } = userSlice.actions;

export default userSlice.reducer;
